module.exports = __webpack_public_path__ + "static/media/FLN1.41e1fc7c.png";